if (!customElements.get('treffen-product-card')) {
  class TreffenProductCard extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.media = this.querySelector('[data-treffen-card-media]');
      this.slides = Array.from(this.querySelectorAll('[data-treffen-card-slide]'));
      this.prevBtn = this.querySelector('[data-treffen-card-prev]');
      this.nextBtn = this.querySelector('[data-treffen-card-next]');
      this.wishlistBtn = this.querySelector('[data-treffen-card-wishlist]');
      this.productId = String(this.dataset.productId || '');

      this.currentIndex = 0;
      this.autoSlideTimer = null;
      this.slideInterval = 1000;

      if (this.slides.length <= 1) {
        this.classList.add('treffen-card--single-image');
        if (this.wishlistBtn) {
          this.syncWishlistState();
          this.wishlistBtn.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.toggleWishlist();
          });
        }
        return;
      }

      this.bindEvents();
      this.updateSlide(0, false);
    }

    bindEvents() {
      this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.addEventListener('mouseleave', this.onMouseLeave.bind(this));

      this.prevBtn?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.goToSlide(this.currentIndex - 1);
        this.restartAutoSlide();
      });

      this.nextBtn?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.goToSlide(this.currentIndex + 1);
        this.restartAutoSlide();
      });

      if (this.wishlistBtn) {
        this.syncWishlistState();
        this.wishlistBtn.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.toggleWishlist();
        });
      }
    }

    onMouseEnter() {
      this.classList.add('treffen-card--hovered');
      this.startAutoSlide();
    }

    onMouseLeave() {
      this.classList.remove('treffen-card--hovered');
      this.stopAutoSlide();
      this.goToSlide(0, false);
    }

    startAutoSlide() {
      this.stopAutoSlide();
      this.autoSlideTimer = window.setInterval(() => {
        this.goToSlide(this.currentIndex + 1);
      }, this.slideInterval);
    }

    restartAutoSlide() {
      if (this.classList.contains('treffen-card--hovered')) {
        this.startAutoSlide();
      }
    }

    stopAutoSlide() {
      if (this.autoSlideTimer) {
        window.clearInterval(this.autoSlideTimer);
        this.autoSlideTimer = null;
      }
    }

    goToSlide(index, animate = true) {
      if (!this.slides.length) return;

      const total = this.slides.length;
      this.currentIndex = ((index % total) + total) % total;

      this.slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === this.currentIndex);
        if (!animate) {
          slide.style.transition = 'none';
          window.requestAnimationFrame(() => {
            slide.style.transition = '';
          });
        }
      });
    }

    getWishlist() {
      try {
        const stored = JSON.parse(window.localStorage.getItem('treffen_wishlist') || '[]');
        return stored.map(String);
      } catch {
        return [];
      }
    }

    setWishlist(ids) {
      window.localStorage.setItem('treffen_wishlist', JSON.stringify(ids));
    }

    syncWishlistState() {
      const isActive = this.getWishlist().includes(this.productId);
      this.wishlistBtn.classList.toggle('is-active', isActive);
      this.wishlistBtn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    }

    toggleWishlist() {
      const wishlist = this.getWishlist();
      const index = wishlist.indexOf(this.productId);

      if (index > -1) {
        wishlist.splice(index, 1);
      } else {
        wishlist.push(this.productId);
      }

      this.setWishlist(wishlist);
      this.syncWishlistState();
    }

    disconnectedCallback() {
      this.stopAutoSlide();
    }
  }

  customElements.define('treffen-product-card', TreffenProductCard);
}
